import React from "react";
import { FaPlus } from "react-icons/fa";
import CustomDropdown from "../Dropdown";

const AssetGuardedActionButton = ({
  userAssets,
  onOptionSelect,
  dropdownOptions,
  truncateText,
  setIsDialogOpen,
  openConfirmDialog,
  navigate,
  navigatePath,
  assetsName,
  disabled = false,
  sell = false,
}) => {
  const handleFallbackClick = () => {
    openConfirmDialog({
      title: "No transactions found",
      message: "Do you want to add an initial transaction first?",
      confirmText: "Yes",
      cancelText: "No",
      cancelClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium border border-info dark:border-gray-300 rounded-md bg-transparent text-info dark:text-grey focus:outline-none",
      confirmClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium rounded-md bg-lightPrimary text-white dark:text-black dark:button-primary-gradient focus:outline-none",
      onConfirm: () => {
        setIsDialogOpen(false);
        navigate(navigatePath, {
          state: {
            autoOpenAssetType: assetsName,
          },
        });
      },
      onCancel: () => setIsDialogOpen(false),
    });
  };

  const dynamicClassName = `flex items-center border border-lightPrimary dark:border-none justify-center w-10 h-9 font-bold rounded-md 
    ${
      disabled
        ? "bg-gray-400 dark:bg-gray-600 text-white cursor-not-allowed border-none"
        : "bg-[radial-gradient(circle_at_10%_10%,rgb(237,237,237),#9e9e9e,#9e9e9e,#9e9e9e)] rounded-md border border-lightPrimary dark:border-none text-lightPrimary dark:text-black dark:button-primary-gradient"
    }`;

  return (
    <div className="">
      {userAssets?.length > 0 ? (
        <CustomDropdown
          options={dropdownOptions}
          name=""
          assetId=""
          icon={<FaPlus />}
          direction="right"
          truncateText={truncateText}
          size={19}
          className={dynamicClassName}
          onOptionSelect={(option) =>
            !disabled && onOptionSelect(option, "Create", {})
          }
          disabled={disabled}
        />
      ) : (
        <button
          onClick={handleFallbackClick}
          className="flex items-center justify-center w-10 h-9 font-bold bg-[radial-gradient(circle_at_10%_10%,rgb(237,237,237),#9e9e9e,#9e9e9e,#9e9e9e)] rounded-md border border-lightPrimary dark:border-none dark:text-black dark:button-primary-gradient rounded-md"
        >
          <FaPlus />
        </button>
      )}
    </div>
  );
};

export default AssetGuardedActionButton;
